/**
 * Store: Product
 * -----------------------------------------------------------------------------
 * Root store for any product variant data
 *
 */
export default {
  namespaced: true,

  state: () => ({
    product: null,
    productsByTag: null,
    productsByTagState: 'loading',
    variant: false,
    sizeGuideActive: false,
  }),

  getters: {
    sizeGuideActive: (state) => state.sizeGuideActive,
    isVariantSelected: (state) => {
      return state.variant.available === null ? false : state.variant.available
    },
  },

  mutations: {

    /**
     * Set product.
     * @param {Object} product - Current PDP product.
     */
    SET_PRODUCT(state, product) {
      state.product = product
    },

    /**
     * Set variant.
     * @param {Object} variant - Currently selected variant.
     */
    SET_VARIANT(state, variant) {
      state.variant = variant
      // change the url to reflect the selected variant
      if (variant && variant.available !== null) {
        const url = new URL(window.location.href)
        url.searchParams.set('variant', variant.id)
        window.history.pushState({}, '', url)
      } else {
        const url = new URL(window.location.href)
        url.searchParams.delete('variant')
        window.history.pushState({}, '', url)
      }
    },

    /**
     * Set colour family.
     * @param {String} family - String value of the colour family for current
     * product.
     */
    SET_COLOUR_FAMILY(state, family) {
      state.colourFamily = family
    },

    /**
     * Sets products by tag array.
     * @param {Array} products - Array of product objects.
     */
    SET_PRODUCTS_BY_TAG(state, products) {
      state.productsByTag = products
    },

    /**
     * Set loading state fo products by tag query.
     * @param {String} status - Loading status.
     */
    SET_PRODUCTS_BY_TAG_STATE(state, status) {
      state.productsByTagState = status
    },

    /**
     * Set size guide active state.
     * @param {Boolean} active - Size guide active state.
     * @returns {Boolean}
     */
    SET_SIZE_GUIDE_ACTIVE(state, active) {
      state.sizeGuideActive = active
    },
  },

  actions: {

    /**
     * Set colour family.
     * @param {String} family - String value of the colour family for current
     * product.
     */
    setColourFamily({ commit }, family) {
      commit('SET_COLOUR_FAMILY', family)
    },

    /**
     * Sets products by tag array.
     * @param {Array} products - Array of product objects.
     */
    setProductsByTag({ commit }, products) {
      commit('SET_PRODUCTS_BY_TAG', products)
    },

    /**
     * Set loading state fo products by tag query.
     * @param {String} status - Loading status.
     */
    setProductsByTagState({ commit }, status) {
      commit('SET_PRODUCTS_BY_TAG_STATE', status)
    },

    /**
     * Set product.
     * @param {Object} product - Current PDP product.
     */
    setProduct({ commit }, product) {
      commit('SET_PRODUCT', product)
    },

    /**
      * Set variant.
      * @param {Object} variant - Currently selected variant.
      */
    setVariant({ commit }, variant) {
      commit('SET_VARIANT', variant)
    },

    /**
     * Set size guide active state.
     * @param {Boolean} active - Size guide active state.
     * @returns {Boolean}
     */
    setSizeGuideActive({ commit }, active) {
      commit('SET_SIZE_GUIDE_ACTIVE', active)
    },
  },
}
